import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  align-items: center;
  border: none;
  background: transparent;
  color: red;
  cursor: pointer;
  & svg {
    font-size: 22px;
  }
`;

export default Button;
